import LoginView           from '@/views/auth/Login'
import LogoutView          from '@/views/auth/Logout'
import LostPasswordView    from '@/views/auth/LostPassword'
import ChangePasswordView  from '@/views/auth/ChangePassword'
import DashboardView       from '@/views/Dashboard'
import CourseCalendarView  from '@/views/course/Calendar'

const LOGIN = {
      name:'Login',
      path:'/',
      component: LoginView,
      localizedName: null, //@TODO add localized named for login
      meta:{
        isHomePage: false,
        requiresAuth: false,
        roles:[]
      }
}

const LOGOUT = {
      name:'Logout',
      path:'/logout',
      component: LogoutView,
      localizedName: null, //@TODO add localized named for logout
      meta:{
        isHomePage: false,
        requiresAuth: false,
        roles:[]
      }
}

const LOST_PASSWORD = {
  name:'LostPassword',
  path:'/optin/password/recover',
  component: LostPasswordView,
  localizedName: null, //@TODO add localized named for logout
  meta:{
    isHomePage: false,
    requiresAuth: false,
    roles:[]
  }
}

const CHANGE_PASSWORD = {
  name:'ChangePassword',
  path:'/optin/password/change/:hash',
  props: true,
  component: ChangePasswordView,
  localizedName: null, //@TODO add localized named for logout
  meta:{
    isHomePage: false,
    requiresAuth: false,
    roles:[]
  }
}

const DASHBOARD = {
  name: 'Dashboard',
  path: '/dashboard',
  component: DashboardView,
  localizedName: null,
  meta:{
    isHomePage: true,
    requiresAuth: true,
    history: true,
    roles: []
  }
}

const COURSE = {
  name: 'course',
  path: '/course/calendar/:course/:calendar?',
  props: true,
  component: CourseCalendarView,
  localizedName: null,
  meta:{
    isHomePage: false,
    requiresAuth: true,
    history: true,
    roles:[],
  }
}

let routes = new Map();

routes.set('login', LOGIN)
routes.set('logout', LOGOUT)
routes.set('lostPassword', LOST_PASSWORD)
routes.set('changePassword', CHANGE_PASSWORD)
routes.set('dashboard', DASHBOARD)
routes.set('course', COURSE)

export default routes
